import { render, staticRenderFns } from "./change-admin-password.vue?vue&type=template&id=177b1692&scoped=true"
import script from "./change-admin-password.vue?vue&type=script&lang=js"
export * from "./change-admin-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b1692",
  null
  
)

export default component.exports